import { createFileRoute } from "@tanstack/react-router";
import { RemindersScreen } from "../components/settings/reminders-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/paminnelser")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <RemindersScreen franchiseId={franchise.id} />;
}
